import { render, staticRenderFns } from "./SelectableButtons.vue?vue&type=template&id=74c47939"
import script from "./SelectableButtons.vue?vue&type=script&lang=ts"
export * from "./SelectableButtons.vue?vue&type=script&lang=ts"
import style0 from "./SelectableButtons.vue?vue&type=style&index=0&id=74c47939&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports